'use client';
import { jsx } from 'react/jsx-runtime';
import { className } from '../../../core/utilities/classnames.utils.js';
import { generateResponsiveClassNames } from '../../../core/utilities/swan-style.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const FlexBox = renderWithRef('FlexBox', null, (n, i)=>{
    var { children: l, alignItems: c, flexWrap: s, flexDirection: p, justifyContent: a, gap: f } = n, u = _object_without_properties(n, [
        "children",
        "alignItems",
        "flexWrap",
        "flexDirection",
        "justifyContent",
        "gap"
    ]);
    let b = className('swan-display-flex', ...generateResponsiveClassNames({
        alignItems: c,
        flexWrap: s,
        flexDirection: p,
        justifyContent: a,
        gap: f
    }, 'flex-box'));
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: i,
        props: _object_spread({}, u),
        classNames: [
            b
        ],
        children: l
    });
});

export { FlexBox };
